/**
 * Custom node to preserve @[name](id) and @[##localId](taskId) format.
 * Parses and renders our mention spans for compatibility with HighlightedMentions.
 */

import { Node, mergeAttributes } from '@tiptap/core';

export interface BugherdMentionOptions {
  HTMLAttributes: Record<string, unknown>;
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    bugherdMention: {
      setMention: (attrs: { id: string; label: string }) => ReturnType;
      unsetMention: () => ReturnType;
    };
  }
}

export const BugherdMention = Node.create<BugherdMentionOptions>({
  name: 'bugherdMention',

  group: 'inline',
  inline: true,
  selectable: false,
  atom: true,

  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },

  addAttributes() {
    return {
      id: {
        default: null,
        parseHTML: element => element.getAttribute('data-id'),
        renderHTML: attributes =>
          attributes.id ? { 'data-id': attributes.id } : {}
      },
      label: {
        default: null,
        parseHTML: element => element.getAttribute('data-label'),
        renderHTML: attributes =>
          attributes.label ? { 'data-label': attributes.label } : {}
      }
    };
  },

  parseHTML() {
    return [
      {
        tag: 'span[data-type="mention"]'
      }
    ];
  },

  renderHTML({ node, HTMLAttributes }) {
    const { id, label } = node.attrs;
    const display = label || id || '';
    return [
      'span',
      mergeAttributes(
        { 'data-type': 'mention' },
        this.options.HTMLAttributes,
        HTMLAttributes,
        { 'data-id': id, 'data-label': label }
      ),
      `@${display}`
    ];
  }
});
